<template>
  <div>
    <p>
      <strong>{{ $t('contract.employment_details.location.label') }}</strong>
      <span class="user-output">{{ details.location }}</span>
    </p>
    <hr />
    <p>
      <strong>{{ $t('contract.employment_details.starting_date.label') }}</strong>
      <span class="user-output">{{ startingDate }}</span>
    </p>

    <p>{{ $t('contract.employment_details.info_paragraph') }}</p>

    <hr />
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  computed: {
    details() {
      return this.$store.state.contract.employmentDetails;
    },
    startingDate() {
      if (this.details.startingDate) {
        let date = new Date(this.details.startingDate);
        return format(date, "dd/MM/yyyy");
      } else {
        return "";
      }
    },
    endingDate() {
      return this.details.temporary ? this.details.endingDate : "";
    }
  }
};
</script>
